import { createSelector } from 'reselect'

const userDataSelector = state => state.user.data

const userDataJwtSelector = createSelector(
	[userDataSelector],
	userData => userData.jwt
)

export default userDataJwtSelector
